import underConstruction from '../../images/underconstruction.jpg';

const UnderConstruction = () => {

    return (
        <>
            <div className="notification linkouter">
                <div className="notification-inner">
                    {/* <div className="notification-under">
                        <img src={underConstruction} alt="underconstruction" />
                    </div> */}
                    {/* <h1>🚧 iAuthor Latex Under Maintenance 🚧</h1>
                    <p>We are currently making improvements. Please check back later.</p> */}

                    <h1>🚧 iAuthor LaTeX is Currently Under Maintenance 🚧</h1>
                    <p>We’re currently performing scheduled maintenance to improve our services. During this time, the product will be temporarily unavailable. We'll back soon by an hour.</p>

                </div>
            </div>
        </>
    )
}
export default UnderConstruction;